import React from 'react';
import { GrMapLocation } from "@react-icons/all-files/gr/GrMapLocation";
import i18n from "i18next";

function School(props){
	return <span className="logo-sc"><a href={props.school.url} target="_blank" >
				<img src={props.school.logo} alt={props.school.name} height={32} max-width={128}/></a></span>
}

// Function to render the description if available
function Description(props) {
    const { description } = props;
    return <div class="school-desc" dangerouslySetInnerHTML={{ __html: description }} />;
  }
  
function Gogole(prop){ 
	var link = "https://www.google.com/maps/place/" + prop.school.location
	return <a href={link} target="_blank"><GrMapLocation className="loc-icon" /></a>
}

function Location(prop) {
	return <div className="area">
				<Gogole school={prop.school}/>			
				<span className="loc">{prop.school.location}</span>
			</div>
}

function Schools(props) {

  	const { data, keys } = props; // Access the data prop

    return (
        <div className="studies">
            <div className="section-header"><h4>{keys.studies}</h4></div>
            {       
                data.Schools.map((school, i) => {
                    return (
                        <div className="study card" id={i} key={i}>
                            <div className="school">
                                <h4>{school.study}</h4>
                                <School school={school} />
                            </div>
                            <div><Location school={school} /></div>
                            {school.date}
                            <div><Description description={school.description} /></div>
                        </div>
                    );
                })
            }
        </div>
    );    
} 


export default Schools;